import { __decorate } from "tslib";
import { Component } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";
import { LocationStrategy } from "@angular/common";
import { WebsiteThemeService } from "../../../../services/website-theme.service";
import { SharedHttp } from "../../../../services/http-client.service";
let CreateStakeComponent = class CreateStakeComponent {
    constructor(sanitizer, location, themeService, httpClient) {
        this.sanitizer = sanitizer;
        this.location = location;
        this.themeService = themeService;
        this.httpClient = httpClient;
        this.errorColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.currency = {};
        this.currenciesExpanded = false;
        this.minAmount = 0;
        this.maxAmount = 0;
        this.minValidAmount = true;
        this.maxValidAmount = true;
        this.wallet = {};
        this.orderType = 'staking';
        this.meanOfPayment = 'bank_slip';
        this.sendButtonDisabled = true;
        this.sendButtonClicked = false;
        this.createStakeError = false;
        this.themeService.getTheme().subscribe((data) => {
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
        });
        location.onPopState(() => {
            this.close();
        });
    }
    ngOnInit() {
        this.currency = this.data.selectedCurrency;
        this.setAvailableBalance();
        this.getMarketSettings();
    }
    setAvailableBalance() {
        this.wallet = this.data.wallets.find(wallet => wallet.wallet.currency.verboseId === this.currency.verboseId);
        if (this.wallet) {
            this.availableBalance = this.wallet.wallet.spendableTotal;
        }
        else {
            this.availableBalance = 0;
        }
    }
    close() {
        this.modal.destroy();
    }
    expandCurrencies() {
        if (this.data.stakeCurrencies) {
            this.currenciesExpanded = !this.currenciesExpanded;
        }
    }
    fillCurrency(value) {
        this.currency = value;
        this.setAvailableBalance();
        this.getMarketSettings();
    }
    getMarketSettings() {
        this.httpClient.get('wallet/getmarketsettings?baseCurrency=' + this.currency.verboseId + '&meanOfPayment=' + this.meanOfPayment + '&orderType=' + this.orderType).subscribe((data) => {
            this.minAmount = Number(data['min_amount']);
            this.maxAmount = Number(data['max_amount']);
            this.checkValidation();
        }, error => {
            this.checkValidation();
        });
    }
    checkValidation() {
        if (!this.amount || typeof this.amount === 'undefined' || this.amount <= 0) {
            this.minValidAmount = true;
            this.maxValidAmount = true;
            this.sendButtonDisabled = true;
            return;
        }
        if (this.amount < this.minAmount) {
            this.minValidAmount = false;
            this.maxValidAmount = true;
            this.sendButtonDisabled = true;
            return;
        }
        if (this.amount > this.availableBalance || this.amount > this.maxAmount) {
            this.minValidAmount = true;
            this.maxValidAmount = false;
            this.sendButtonDisabled = true;
            return;
        }
        this.minValidAmount = true;
        this.maxValidAmount = true;
        this.sendButtonDisabled = false;
    }
    setMaxAmount() {
        this.amount = this.availableBalance;
        this.checkValidation();
    }
    createStake() {
        if (this.sendButtonDisabled) {
            return;
        }
        const data = {
            currency: this.currency.verboseId,
            amount: this.amount,
            walletId: this.wallet.wallet.verboseId
        };
        this.sendButtonClicked = true;
        this.httpClient.post('staking/stake', data).subscribe(() => {
            this.success();
            this.close();
        }, error => {
            this.sendButtonClicked = false;
            this.sendButtonDisabled = false;
            this.createStakeError = true;
        });
    }
};
CreateStakeComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: LocationStrategy },
    { type: WebsiteThemeService },
    { type: SharedHttp }
];
CreateStakeComponent = __decorate([
    Component({
        selector: 'ecd-create-stake',
        template: __importDefault(require("./create-stake.component.html")).default,
    })
], CreateStakeComponent);
export { CreateStakeComponent };
